var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../components/UnlinkedApplicationForm";
import { AutoEntities, AutoEntity, addAutoEntity, editAutoEntity, removeAutoEntity, setEntityState, } from "../../../features/unlinked-application/unlinkedApplicationSlice";
import { Button, DateTextField, TextField } from "@savvyinsure/react-ui";
import { clickedAddButton, clickedCancelButton, clickedDeleteButton, clickedEditButton, completedEntityForm, completedPage, viewedWidgetPage, } from "../../../lib/Avo";
import AppBody from "../../../components/AppBody";
import Badge from "../../../components/Badge";
import ConfirmationDialog from "../../../components/ConfirmationDialog";
import { FaExclamationTriangle } from "react-icons/fa";
import Header from "../../../components/Header";
import Image from "../../../components/Image";
import { PAGES } from "../../../lib/TrellisAnalytics";
import { PHASE } from "../../../routeConfig";
import { PivotReason } from "../../../features/applicant/applicantSlice";
import { SavvyMaritalStatus } from "@savvyinsure/savvy-auto-policy/lib/enums";
import { ToggleButtonGroup } from "../../../components/ToggleButton";
import { batch } from "react-redux";
import classNames from "classnames";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import { genderOptions } from "../../../features/unlinked-application/constants";
import { getAgeFromDOB } from "../../../utils/getAgeFromDOB";
import isOdd from "../../../utils/isOdd";
import { otherIssuer } from "../../../lib/constants";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppSelector from "../../../hooks/useAppSelector";
import { useDidMount } from "rooks";
import useEventPublisher from "../../../hooks/useEventPublisher";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import useIsFlagOn from "../../../features/feature-flags/hooks/useIsFlagOn";
import { v4 as uuid } from "uuid";
dayjs.extend(customParseFormat);
var typeOfEntity = AutoEntity.Driver;
var spouseInPolicy = true;
var maritalStatusOptions = [
    { value: SavvyMaritalStatus.Single, label: "Single" },
    { value: SavvyMaritalStatus.Married, label: "Married" },
    { value: SavvyMaritalStatus.Other, label: "Other" },
];
function ToolTip() {
    return (React.createElement("div", { className: "mb-4 flex w-full items-center rounded border border-dashed bg-white-200 p-4 text-left outline-gray-200" },
        React.createElement("div", { className: "text-medium-gray text-sm desktop:text-[13px]" }, "All adult household members need to be listed on a policy even if they don't drive."),
        React.createElement("div", { className: "ml-2 flex-none items-center justify-center" },
            React.createElement(Image, { width: "32", height: "32", src: "/assets/icons/family.svg" }))));
}
function Listing() {
    var drivers = useAppSelector(function (_a) {
        var auto = _a.unlinkedApplication.auto;
        return auto.drivers;
    });
    var push = useHistory().push;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var _a = React.useState(""), driverIdToRemove = _a[0], setDriverIdToRemove = _a[1];
    var _b = React.useState(false), confirmationDialogOpen = _b[0], setConfirmationDialogOpen = _b[1];
    var dispatch = useAppDispatch();
    var eventPublisher = useEventPublisher();
    var isPremiumEnabled = useIsFlagOn("unlinkedApplication_premiumEnabled_frontend");
    var isIssuerPageFirst = useIsFlagOn("unlinkedApplication_issuerPageFirst_frontend");
    var editId = useAppSelector(function (state) {
        return state.unlinkedApplication.auto.entities[AutoEntities.drivers].editId;
    });
    var isBundleAutoFromHome = useAppSelector(function (state) {
        return state.applicant.bundlePivotReason === PivotReason.BundleAutoFromHome;
    });
    var hasCurrentAutoIssuer = useAppSelector(function (state) {
        return state.applicant.currentIssuer.auto &&
            state.applicant.currentIssuer.auto.id !== otherIssuer.id;
    });
    function getNextRoute() {
        if (!isIssuerPageFirst && !isBundleAutoFromHome && !hasCurrentAutoIssuer) {
            return PHASE.SELECT_AUTO_ISSUER;
        }
        if (isPremiumEnabled) {
            return PHASE.UNLINKED_APPLICATION_AUTO_PAYMENT_PERIOD;
        }
        return PHASE.UNLINKED_APPLICATION_AUTO_POLICY_HOLDER_ADDRESS;
    }
    var nextRoute = getNextRoute();
    var invalidDriver = drivers.find(function (driver) { return Object.values(driver).every(Boolean) === false; });
    var marriedDrivers = drivers.filter(function (driver) { return driver.maritalStatus === SavvyMaritalStatus.Married; });
    var isMissingSpouse = isOdd(marriedDrivers.length);
    var hasValidDrivers = drivers.length > 0 && !invalidDriver;
    function handleSubmit(ev) {
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: ev.currentTarget.textContent, optionSelected: ev.currentTarget.textContent, pageName: PAGES.UNLINKED_APPLICATION_AUTO_DRIVERS_REVIEW }));
        if (isMissingSpouse) {
            return dispatch(setEntityState({ drivers: { mode: "add", editId: undefined } }));
        }
        if (!hasValidDrivers) {
            return dispatch(setEntityState({
                drivers: { mode: "edit", editId: invalidDriver === null || invalidDriver === void 0 ? void 0 : invalidDriver.id },
            }));
        }
        push(nextRoute);
    }
    function handleCancelConfirmationDialog() {
        setConfirmationDialogOpen(false);
        setDriverIdToRemove("");
    }
    function handleRemoveConfirmationDialog() {
        clickedDeleteButton(__assign(__assign({}, commonAnalyticsProperties), { typeOfEntity: typeOfEntity }));
        dispatch(removeAutoEntity({ entity: typeOfEntity, id: driverIdToRemove }));
        setConfirmationDialogOpen(false);
    }
    useDidMount(function () {
        if (editId) {
            return dispatch(setEntityState({ drivers: { mode: "edit" } }));
        }
        viewedWidgetPage(__assign(__assign({}, commonAnalyticsProperties), { segmentPageName_: PAGES.UNLINKED_APPLICATION_AUTO_DRIVERS_REVIEW }));
        eventPublisher.transitionView(PAGES.UNLINKED_APPLICATION_AUTO_DRIVERS_REVIEW);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames("flex flex-col pb-6 pt-6", {
                "pb-2": isMissingSpouse,
                "pb-6": !isMissingSpouse,
            }) },
            React.createElement(UnlinkedApplicationForm.Header, { className: "grow" }, "Your drivers"),
            isMissingSpouse ? (React.createElement("p", { className: "mt-0.5 text-sm text-red" }, "Uneven numbers of married drivers are not allowed. Please add everyone's spouse, even if not living in the household or driving.")) : null),
        React.createElement("div", { className: "flex flex-col" },
            React.createElement("ul", { className: "mb-6 space-y-2" }, drivers.map(function (driver) {
                var isValid = Object.values(driver).every(Boolean);
                var gender = genderOptions.find(function (_a) {
                    var value = _a.value;
                    return value === driver.gender;
                });
                var tertiaryTextContent = !isValid
                    ? "Missing information"
                    : undefined;
                return (React.createElement(UnlinkedApplicationForm.ListItemWithActionButtons, { key: driver.id, icon: React.createElement(Image, { width: "24", height: "24", src: "/assets/icons/profile-blue.svg" }), secondaryIcon: !isValid ? React.createElement(FaExclamationTriangle, null) : null, primaryText: "".concat(driver.firstName, " ").concat(driver.lastName), secondaryText: React.createElement("span", null, gender === null || gender === void 0 ? void 0 :
                        gender.label,
                        " \u00B7 ",
                        getAgeFromDOB(driver.dateOfBirth),
                        " ",
                        "\u00B7",
                        " ",
                        React.createElement("span", { className: "capitalize" }, driver.maritalStatus)), tertiaryText: !isValid ? React.createElement(Badge, { text: tertiaryTextContent }) : null, actionButtons: [
                        React.createElement(UnlinkedApplicationForm.ListItemActionButton, { key: "edit", "data-testid": "edit-driver-action-button", icon: React.createElement(Image, { width: "18", height: "18", className: "max-w-none", src: "/assets/icons/pencil.svg" }), onClick: function () {
                                clickedEditButton(__assign(__assign({}, commonAnalyticsProperties), { typeOfEntity: typeOfEntity }));
                                dispatch(setEntityState({
                                    drivers: { mode: "edit", editId: driver.id },
                                }));
                            } }),
                        React.createElement(UnlinkedApplicationForm.ListItemActionButton, { key: "remove", isVisible: drivers.length > 1, icon: React.createElement(Image, { width: "24", height: "24", className: "max-w-none", src: "/assets/icons/cross-mark.svg" }), onClick: function () {
                                setDriverIdToRemove(driver.id);
                                setConfirmationDialogOpen(true);
                            } }),
                    ] }));
            })),
            hasValidDrivers ? (React.createElement("button", { onClick: function () {
                    clickedAddButton(__assign(__assign({}, commonAnalyticsProperties), { typeOfEntity: typeOfEntity }));
                    dispatch(setEntityState({ drivers: { mode: "add", editId: undefined } }));
                }, className: "mx-auto inline-flex items-center rounded-[48px] border-2 border-savvy p-4 text-base font-bold uppercase leading-none text-savvy" },
                React.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { d: "M8.5 2.66699V8.00048M8.5 13.334V8.00048M8.5 8.00048H3.16651M8.5 8.00048H13.8335", stroke: "currentColor", strokeWidth: "1.33333" }),
                    React.createElement("path", { d: "M8.5 2.66699V8.00048M8.5 13.334V8.00048M8.5 8.00048H3.16651M8.5 8.00048H13.8335", stroke: "currentColor", strokeWidth: "1.33333" })),
                React.createElement("span", { className: "ml-1" }, "Add a Driver"))) : null),
        React.createElement("div", { className: "mt-auto pb-8" },
            React.createElement(ToolTip, null),
            React.createElement(Button, { onClick: handleSubmit, disabled: drivers.length === 0 }, isMissingSpouse
                ? "Add Missing Spouse"
                : !hasValidDrivers
                    ? "Add Missing Info"
                    : "Continue")),
        React.createElement(ConfirmationDialog, { title: "Remove Driver", message: "Are you sure you want to remove this driver? This action cannot be undone.", confirmButtonText: "Remove", cancelButtonText: "Cancel", isOpen: confirmationDialogOpen, onCancel: handleCancelConfirmationDialog, onConfirm: handleRemoveConfirmationDialog, icon: React.createElement(Image, { width: "48", height: "48", src: "/assets/icons/profile-blue.svg" }) })));
}
function AddOrEdit() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var push = useHistory().push;
    var _j = useAppSelector(function (state) { return state.unlinkedApplication; }), _k = _j.auto, drivers = _k.drivers, entities = _k.entities, policyHolder = _j.policyHolder;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var dispatch = useAppDispatch();
    var eventPublisher = useEventPublisher();
    var _l = entities.drivers, mode = _l.mode, editId = _l.editId;
    var driverToEdit = React.useMemo(function () {
        return mode === "edit"
            ? drivers.find(function (driver) { return driver.id === editId; })
            : undefined;
    }, [drivers, editId, mode]);
    var canAddSpouse = ((_a = drivers[0]) === null || _a === void 0 ? void 0 : _a.maritalStatus) === SavvyMaritalStatus.Married && mode === "add";
    var spouseAlreadyAdded = ((_b = drivers[1]) === null || _b === void 0 ? void 0 : _b.maritalStatus) === SavvyMaritalStatus.Married;
    var isAddingSpouse = !spouseAlreadyAdded &&
        canAddSpouse &&
        spouseInPolicy &&
        drivers.length === (mode === "add" ? 1 : 2);
    var isPolicyHolder = drivers.length === 0 ||
        drivers.findIndex(function (d) { return d.id === (driverToEdit === null || driverToEdit === void 0 ? void 0 : driverToEdit.id); }) === 0;
    var isPolicyHolderSpouse = isAddingSpouse ||
        (spouseAlreadyAdded && ((_c = drivers[1]) === null || _c === void 0 ? void 0 : _c.id) === (driverToEdit === null || driverToEdit === void 0 ? void 0 : driverToEdit.id));
    var defaultDateOfBirth = drivers.length === 0
        ? policyHolder.dateOfBirth
        : ((_d = driverToEdit === null || driverToEdit === void 0 ? void 0 : driverToEdit.dateOfBirth) !== null && _d !== void 0 ? _d : "");
    var shouldPrefillMaritalStatus = ((_e = drivers[0]) === null || _e === void 0 ? void 0 : _e.maritalStatus) === SavvyMaritalStatus.Married &&
        drivers.length === 1 &&
        mode === "add" &&
        spouseInPolicy;
    var newDriverId = uuid();
    var _m = useForm({
        mode: "all",
        defaultValues: {
            id: (_f = driverToEdit === null || driverToEdit === void 0 ? void 0 : driverToEdit.id) !== null && _f !== void 0 ? _f : newDriverId,
            firstName: drivers.length === 0
                ? policyHolder.firstName
                : ((_g = driverToEdit === null || driverToEdit === void 0 ? void 0 : driverToEdit.firstName) !== null && _g !== void 0 ? _g : ""),
            lastName: drivers.length === 0
                ? policyHolder.lastName
                : ((_h = driverToEdit === null || driverToEdit === void 0 ? void 0 : driverToEdit.lastName) !== null && _h !== void 0 ? _h : ""),
            gender: driverToEdit === null || driverToEdit === void 0 ? void 0 : driverToEdit.gender,
            dateOfBirth: defaultDateOfBirth,
            maritalStatus: shouldPrefillMaritalStatus
                ? SavvyMaritalStatus.Married
                : driverToEdit === null || driverToEdit === void 0 ? void 0 : driverToEdit.maritalStatus,
        },
    }), register = _m.register, _o = _m.formState, errors = _o.errors, isValid = _o.isValid, handleSubmit = _m.handleSubmit, setValue = _m.setValue, watch = _m.watch, getValues = _m.getValues, reset = _m.reset;
    var genderValue = watch("gender");
    var maritalStatus = watch("maritalStatus");
    var dateOfBirthInput = register("dateOfBirth", {
        required: true,
        minLength: 10,
        validate: __assign({ isValidDate: function (v) { return dayjs(v, "MM/DD/YYYY", true).isValid(); }, isBeforeToday: function (v) {
                return dayjs(v, "MM/DD/YYYY", true).isBefore(dayjs()) ||
                    "Date of birth must be in the past";
            } }, (isPolicyHolder && {
            isAtleastEighteen: function (value) {
                return dayjs().diff(dayjs(value, "MM/DD/YYYY", true), "year") >= 18 ||
                    "You must be 18 or older to be the primary driver";
            },
        })),
    });
    var onSubmit = handleSubmit(function (data) {
        var hasDrivers = drivers.length > 0;
        var policyHolderMarriageStatus = hasDrivers && mode === "add"
            ? drivers[0].maritalStatus
            : getValues("maritalStatus");
        var policyHolderIsMarried = policyHolderMarriageStatus === SavvyMaritalStatus.Married;
        var canAddNewDriver = !isAddingSpouse &&
            policyHolderIsMarried &&
            drivers.length === (mode === "add" ? 0 : 1);
        completedEntityForm(__assign(__assign({}, commonAnalyticsProperties), { typeOfEntity: typeOfEntity, phaseMode: mode, driverIsMarried: data.maritalStatus === SavvyMaritalStatus.Married, driverIsPolicyholder: isPolicyHolder }));
        if (mode === "add") {
            dispatch(addAutoEntity({ entity: AutoEntity.Driver, data: data }));
        }
        else {
            dispatch(editAutoEntity({ entity: AutoEntity.Driver, data: data }));
        }
        if (canAddNewDriver) {
            dispatch(setEntityState({ drivers: { mode: "add", editId: null } }));
            reset();
        }
        var showDiscounts = isPolicyHolder || isPolicyHolderSpouse;
        if (showDiscounts) {
            push({
                pathname: PHASE.UNLINKED_APPLICATION_AUTO_APPLICABLE_DISCOUNTS,
                search: "?driverId=".concat(data.id),
            });
        }
    });
    useDidMount(function () {
        viewedWidgetPage(__assign(__assign({}, commonAnalyticsProperties), { segmentPageName_: PAGES.UNLINKED_APPLICATION_AUTO_DRIVERS_EDIT }));
        eventPublisher.transitionView(PAGES.UNLINKED_APPLICATION_AUTO_DRIVERS_EDIT);
    });
    React.useEffect(function () {
        register("gender", {
            required: true,
            validate: function (value) {
                return genderOptions.some(function (option) {
                    var _a;
                    return [option.value.toLowerCase(), option.label.toLowerCase()].includes((_a = value === null || value === void 0 ? void 0 : value.toLowerCase()) !== null && _a !== void 0 ? _a : "");
                }) || "Please select a valid gender";
            },
        });
        register("maritalStatus", { required: true });
    }, [register]);
    return (React.createElement(React.Fragment, null,
        React.createElement(UnlinkedApplicationForm.Header, { className: "mb-4 mt-6" }, isPolicyHolder
            ? "Tell us about yourself"
            : isAddingSpouse
                ? "Tell us about who you are married to"
                : "Driver information"),
        React.createElement("form", { className: "flex grow flex-col", onSubmit: onSubmit },
            React.createElement("div", { className: "flex flex-col gap-4" },
                React.createElement(TextField, __assign({ id: "firstName", label: "First Name", "aria-invalid": Boolean(errors === null || errors === void 0 ? void 0 : errors.firstName) }, register("firstName", {
                    required: true,
                }))),
                React.createElement(TextField, __assign({ id: "lastName", label: "Last Name", "aria-invalid": Boolean(errors === null || errors === void 0 ? void 0 : errors.lastName) }, register("lastName", {
                    required: true,
                }))),
                React.createElement(DateTextField, { id: "dateOfBirth", type: "text", label: "Date of Birth (MM/DD/YYYY)", defaultValue: defaultDateOfBirth, format: "##/##/####", placeholder: "mm/dd/yyyy", mask: "", onBlur: dateOfBirthInput.onBlur, name: dateOfBirthInput.name, onChange: dateOfBirthInput.onChange, getInputRef: dateOfBirthInput.ref, "aria-invalid": Boolean(errors.dateOfBirth) })),
            React.createElement("div", { className: "mt-2 flex flex-col gap-2" },
                React.createElement(ToggleButtonGroup, { variant: "condensed", id: "gender", label: "Gender", options: genderOptions, value: genderValue, onChange: function (value) {
                        return setValue("gender", value, {
                            shouldValidate: true,
                        });
                    } }),
                !isAddingSpouse ? (React.createElement(ToggleButtonGroup, { variant: "condensed", id: "maritalStatus", label: "Marital Status", options: maritalStatusOptions, value: maritalStatus, onChange: function (value) {
                        return setValue("maritalStatus", value, {
                            shouldValidate: true,
                        });
                    } })) : null),
            React.createElement("div", { className: "mt-4 flex w-full grow flex-col items-center pb-6" },
                React.createElement(Button, { disabled: !isValid }, "Continue"),
                drivers.length > 0 ? (React.createElement("button", { type: "button", className: "mt-4 text-base font-bold text-savvy", onClick: function () {
                        clickedCancelButton(__assign(__assign({}, commonAnalyticsProperties), { typeOfEntity: typeOfEntity }));
                        batch(function () {
                            dispatch(setEntityState({
                                drivers: { mode: "listing", editId: "" },
                            }));
                            if (isAddingSpouse) {
                                dispatch(setEntityState({ drivers: { editId: drivers[0].id } }));
                                dispatch(editAutoEntity({
                                    entity: AutoEntity.Driver,
                                    data: {
                                        id: drivers[0].id,
                                        maritalStatus: SavvyMaritalStatus.Single,
                                    },
                                }));
                            }
                        });
                        isAddingSpouse
                            ? (spouseInPolicy = false)
                            : (spouseInPolicy = true);
                    } }, isAddingSpouse ? "I am not married" : "Cancel")) : null,
                mode === "edit" &&
                    driverToEdit &&
                    drivers.length > 1 &&
                    !isPolicyHolder ? (React.createElement("button", { type: "button", className: "mt-auto font-bold text-red", onClick: function () {
                        clickedDeleteButton(__assign(__assign({}, commonAnalyticsProperties), { typeOfEntity: typeOfEntity }));
                        dispatch(removeAutoEntity({
                            entity: typeOfEntity,
                            id: driverToEdit.id,
                        }));
                    } }, "Remove")) : null))));
}
export default function UnlinkedApplicationAutoDrivers() {
    var _a = useAppSelector(function (state) { return state.unlinkedApplication.auto; }), drivers = _a.drivers, entities = _a.entities;
    var mode = ((entities === null || entities === void 0 ? void 0 : entities.drivers) || { mode: "listing" }).mode;
    var dispatch = useAppDispatch();
    var shouldShowForm = mode !== "listing";
    var shouldGoBackToListing = drivers.length > 0 && shouldShowForm;
    var goBackOverride = React.useCallback(function () {
        dispatch(setEntityState({ drivers: { mode: "listing", editId: "" } }));
    }, [dispatch]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { showDropShadow: true, goBackOverride: shouldGoBackToListing ? goBackOverride : undefined },
            React.createElement(UnlinkedApplicationForm.Progress, null)),
        React.createElement(AppBody, null,
            React.createElement(UnlinkedApplicationForm.ScrollingContainer, null, shouldShowForm ? React.createElement(AddOrEdit, { key: drivers.length }) : React.createElement(Listing, null)))));
}
